import { Link } from 'react-router-dom'
import React, { useEffect, useState, useRef } from 'react'

import { Cart } from './components/Cart'
import Heart from 'components/Icons/Heart'
import useConfig from 'store/ConfigProvider'
import PhoneBox from './components/PhoneBox'
import SearchBox from './components/SearchBox'
import ProfileBox from './components/ProfileBox'
import { MobileAndTabletView } from '../DeviceDetect'
import Categories from 'components/Widgets/Categories'
import detectOutside from '../../helpers/detectOutside'
import WishlistDropdown from './components/WishlistDropdown'
import { useWishlistContext } from '../../store/WishlistContext'
import AffiliateToolbar from 'components/Affiliate/AffiliateToolbar'

const Header = () => {
  const [chatOpened, setChatOpened] = useState(false)
  const [isWishlistOpen, setIsWishlistOpen] = useState(false)

  const wishlistRef = useRef(null)

  const { settings, categories } = useConfig()
  const { wishlistProducts } = useWishlistContext()

  const handleWishlistClose = () => {
    setIsWishlistOpen(false)
  }

  detectOutside(wishlistRef, handleWishlistClose)

  useEffect(() => {
    if (!Array.isArray(window.$crisp)) window.$crisp = []
    window.$crisp.push([
      'on',
      'chat:opened',
      () => {
        setChatOpened(true)
      },
    ])
    window.$crisp.push([
      'on',
      'chat:closed',
      () => {
        setChatOpened(false)
      },
    ])
  }, [])

  return (
    <div className="header" style={{ display: chatOpened ? 'none' : 'block' }}>
      <div className="header-top">
        <MobileAndTabletView>
          <Categories categories={categories} mobileTop={true} />
        </MobileAndTabletView>
        <Link className="logo" to="/">
          <img src="/img/logo.png" alt="logo" />
        </Link>
        <SearchBox type="desktop" />
        <div className="header-info">
          <PhoneBox number={settings.phone_number} />
          <div ref={wishlistRef} className="relative">
            <button
              onClick={() => setIsWishlistOpen(!isWishlistOpen)}
              className="relative flex items-center justify-center cursor-pointer"
            >
              <Heart />
              {wishlistProducts.length > 0 && (
                <span className="absolute w-4 h-4 rounded-full bg-[#ff2337] text-[10px] text-white flex items-center justify-center -right-[17%] -top-[6%] transform-translate-y-1/2">
                  {wishlistProducts.length}
                </span>
              )}
            </button>
            <WishlistDropdown
              open={isWishlistOpen}
              onClose={handleWishlistClose}
            />
          </div>

          <Cart />
          <ProfileBox />
        </div>
      </div>
      <SearchBox type="mobile" />
      <AffiliateToolbar />
    </div>
  )
}

export default Header
